import React, { useEffect, useState } from "react";

import { Modal, Select } from "antd";

import styles from "./UnsavedChangesModal.module.scss";

interface UpscaleMapModalProps {
  isVisible: boolean;
  onConfirm: (selectedPlay: string) => void;
  onCancel: () => void;
  containerRef: React.RefObject<HTMLElement> | null;
  availablePlays: string[];
  isUpscaling: boolean;
}

export const UpscaleMapModal: React.FC<UpscaleMapModalProps> = ({
  isVisible,
  onConfirm,
  onCancel,
  containerRef,
  availablePlays,
  isUpscaling
}) => {
  const [selectedPlay, setSelectedPlay] = useState<string | undefined>(undefined);
  const container = containerRef?.current;

  const handleOk = () => {
    if (selectedPlay) {
      onConfirm(selectedPlay);
    }
  };

  const handleCancel = () => {
    setSelectedPlay(undefined);
    onCancel();
  };

  // Reset selection when modal opens
  useEffect(() => {
    if (isVisible) {
      setSelectedPlay(undefined);
    }
  }, [isVisible]);

  return (
    <Modal
      title={<div className={styles.headerContainer}>Upscale Map</div>}
      getContainer={container ? () => container : false}
      open={isVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okButtonProps={{
        disabled: !selectedPlay || isUpscaling,
        loading: isUpscaling
      }}
      okText={isUpscaling ? "Upscaling..." : "Upscale"}
      cancelButtonProps={{ disabled: isUpscaling }}
      className={styles.unsavedChangesModal}
      style={{ top: "15%" }}>
      <div style={{ marginBottom: "16px" }}>
        <p style={{ marginBottom: "12px" }}>
          Upscale 2D Geo to allow for 3D Sampling Functionality
        </p>
        <div>Select a play to upscale the maps for:</div>
      </div>
      <Select
        style={{ width: "100%" }}
        placeholder="Select a play"
        value={selectedPlay}
        onChange={setSelectedPlay}
        disabled={isUpscaling}
        showSearch
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={availablePlays.map((play) => ({
          label: play,
          value: play
        }))}
      />
    </Modal>
  );
};
